export default __webpack_public_path__ + "static/plan-12-meal-rollover-77ddbe8446c26d819bca9b48900a8bee.png";